export const AUTH0_METADATA_KEY = 'https://meowwolf.com/user_metadata'

export const AUTH_ALGORITHM = process.env.AUTH_ALGORITHM as string
export const VECTOR_SECRET = process.env.VECTOR_SECRET as string
export const SECURITY_KEY_SECRET = process.env.SECURITY_KEY_SECRET as string

export const AUTH_SALT = process.env.AUTH_SALT as string

export const ID_TOKEN_HEADER_KEY = 'x-mw-id-token'
export const ACC_TOKEN_HEADER_KEY = 'x-mw-access-token'
export const ACC_TOKEN_EXP_HEADER_KEY = 'x-mw-access-exp'

export const MOBILE_APP_VERIFY_SECRET = process.env.MOBILE_APP_VERIFY_SECRET as string
export const MOBILE_APP_IV = process.env.MOBILE_APP_IV as string

export const AUTH0_SECRET = process.env.AUTH0_SECRET as string

export const AUTH0_CLIENT_SECRET = process.env.AUTH0_CLIENT_SECRET as string

export const INTERNAL_REDIRECT_PARAM_KEY = 'mwRed'
